<template>
  <div class="fp-step fp-step-verification">
    <div class="fp-step-header">
      <button type="button" class="fp-back-btn" @click="$emit('go-back')" t_label="btn_emp2_Back_ForgotPasswordVerification">
        <img 
          src="https://cdn.adsalecdn.com/EMP/2-0/BuyerIdx/All_Categories.svg" 
          alt="back" 
          class="fp-back-icon"
        />
      </button>
      <h1 class="fp-step-title">{{ $t('lbl_emp2_ForgotPasswordTitle') }}</h1>
    </div>

    <div class="fp-form-group">
      <div class="fp-info-text">
        {{ $t('lbl_emp2_WillSendCodeToResetPassword') }}
      </div>
    </div>

    <div class="fp-form-group">
      <slot name="verification-buttons">
        <!-- 如果是从邮箱登录进入的，显示发送到邮箱的按钮 -->
        <div v-if="loginMethod === 'email'" class="fp-alternative-login">
          <button class="fp-btn-secondary" @click="$emit('switch-login', 'send-reset-code-email')" t_label="btn_emp2_SendCodeToEmail_FromVerification">
            {{ $t('lbl_emp2_SendCodeToEmail', { emailInput: email }) }}
          </button>
        </div>
        <!-- 如果是从手机号登录进入的，显示发送到手机的按钮 -->
        <div v-if="loginMethod === 'mobile'" class="fp-alternative-login">
          <button class="fp-btn-secondary" @click="$emit('switch-login', 'send-reset-code-mobile')" t_label="btn_emp2_SendCodeToMobile_FromVerification">
            {{ $t('lbl_emp2_SendCodeToMobile', { countryCode: countryCodePlain, mobileNumber: mobileNumber }) }}
          </button>
        </div>
        <!-- 如果是从用户名登录进入的，显示两个选项 -->
        <div v-if="loginMethod === 'username'" class="fp-alternative-login">
          <button class="fp-btn-secondary" @click="$emit('switch-login', 'send-reset-code-email')" t_label="btn_emp2_SendCodeToEmailOption_FromVerification">
            {{ $t('lbl_emp2_SendCodeToEmailOption') }}
          </button>
          <button class="fp-btn-secondary" @click="$emit('switch-login', 'send-reset-code-mobile')" t_label="btn_emp2_SendCodeToMobileOption_FromVerification">
            {{ $t('lbl_emp2_SendCodeToMobileOption') }}
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPasswordVerification',
  props: {
    loginMethod: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: ''
    },
    mobileNumber: {
      type: String,
      default: ''
    },
    countryCode: {
      type: String,
      default: '+86'
    }
  },
  computed: {
    countryCodePlain() {
      // 翻译文本中已包含 '+'，因此这里要去掉可能的 '+'
      return String(this.countryCode || '').replace(/^\+/, '');
    }
  }
};
</script>

<style scoped>
.fp-step {
  gap: 24px !important;
  padding: 40px 24px !important;
  margin: -40px -24px !important;
  width: calc(100% + 48px) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  align-self: stretch !important;
}

.fp-step-verification {
  gap: 24px !important;
}

.fp-step-header {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.fp-back-btn {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  position: relative;
}

.fp-back-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
}

.fp-back-btn .fp-back-icon {
  width: 20px;
  height: 20px;
  transform: scaleX(-1);
}

.fp-step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
  flex: 1;
}

.fp-form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 0;
  width: 100%;
}

.fp-info-text {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
  text-align: left;
  width: 100%;
  margin: 0;
  padding: 0;
}

.fp-alternative-login {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  width: 100%;
}

.fp-btn-secondary {
  align-self: stretch;
  height: 42px;
  padding: 0 24px;
  border-radius: 999px;
  outline: 1px rgba(0, 0, 0, 0.60) solid;
  outline-offset: -1px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  background: white !important;
  background-color: white !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 21px;
  word-wrap: break-word;
  box-sizing: border-box;
}

.fp-btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  outline-color: rgba(0, 0, 0, 0.60);
}
</style>

<!-- 全局样式覆盖 -->
<style>
.fp-alternative-login .fp-btn-secondary {
  background: white !important;
  background-color: white !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.80) !important;
}

.fp-alternative-login .fp-btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.80) !important;
}
</style>

